import { render, staticRenderFns } from "./SystemConfigFunction.vue?vue&type=template&id=29be8071"
import script from "./SystemConfigFunction.vue?vue&type=script&lang=js"
export * from "./SystemConfigFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports